<template>
  <div class="page has-sidebar has-sidebar-fluid has-sidebar-expand-xl">
    <!-- .page-inner -->
    <div class="page-inner page-inner-fill position-relative">
      <header class="page-navs shadow-sm">
        <!-- .input-group -->
        <div class="input-group has-clearable">
          <button type="button" class="close" aria-label="Close">
            <span aria-hidden="true">
              <em class="fa fa-times-circle"></em>
            </span>
          </button>
          <label class="input-group-prepend" for="searchClients">
            <span class="input-group-text">
              <span class="oi oi-magnifying-glass"></span>
            </span>
          </label>
          <input type="text" class="form-control" id="searchClients" @keyup="inputText" data-filter=".board .list-group-item" placeholder="Find contact">
        </div><!-- /.input-group -->
      </header>

      <div class="board p-0 perfect-scrollbar" id="container">
        <!-- .list-group -->
        <div class="list-group list-group-flush list-group-divider border-top" data-toggle="radiolist">
          <template v-for="(list, i) in contact_list">
            <div class="list-group-item" :class="{ 'active' : i == 0}" data-toggle="sidebar" data-sidebar="show"  >
              <a @click="getDetail(list)" class="stretched-link"></a>
              <div class="list-group-item-figure">
                <div class="tile tile-circle" :class="list.bg_color">{{list.initial}}</div>
              </div>
              <div class="list-group-item-body">
                <h4 class="list-group-item-title">{{list.full_name}}</h4>
                <p class="list-group-item-text">{{list.emp_unit}}</p>
              </div>
            </div>
          </template>

          <div class="list-group-item" v-show="loading">
            <!-- .list-group-item-body -->
            <div class="list-group-item-body text-center py-4">
              <!-- .spinner -->
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div><!-- /.spinner -->
            </div><!-- /.list-group-item-body -->
          </div>
        </div>
      </div>
    </div>
    <div class="page-sidebar bg-light">
      <!-- .sidebar-header -->
      <header class="sidebar-header d-xl-none">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="#" onclick="Looper.toggleSidebar()"><em class="breadcrumb-icon fa fa-angle-left mr-2"></em>Back</a>
            </li>
          </ol>
        </nav>
      </header>
      <div class="sidebar-section sidebar-section-fill">
        <h1 class="page-title">
          <em class="far fa-building text-muted mr-2"></em> {{detail.name}} </h1>
        <p class="text-muted"> {{ detail.unit_name }} </p>
        <div class="card">
          <!-- .card-body -->
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h2 id="client-billing-contact-tab" class="card-title"> Address </h2>
            </div>
            <address> {{detail.street}}, {{detail.city}}<br> {{detail.state_name}}, {{detail.postal_code}}<br> {{detail.country_name}} </address>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
        <div class="card mt-4">
          <!-- .card-body -->
          <div class="card-body">
            <h2 class="card-title"> Contacts </h2><!-- .table-responsive -->
            <div class="table-responsive">
              <table class="table table-hover" style="min-width: 678px" aria-label="Contact List">
                <thead>
                <tr>
                  <th id="type"> Type </th>
                  <th id="email"> Email </th>
                  <th id="phone"> Phone </th>
                  <th id=""></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="align-middle"> Primary </td>
                  <td class="align-middle"> {{detail.email}}</td>
                  <td class="align-middle"> {{detail.phone_number}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {BPagination} from "bootstrap-vue";
import PaginationInfo from "../../PaginationInfo";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "ContactList",
  components:{},
  data(){
    return {
      contact_list:[],
      items:[],
      currentPage:1,
      perPage:15,
      total:0,
      ps:null,
      loading:false,
      bg_color:['bg-blue','bg-indigo','bg-purple','bg-pink','bg-red','bg-orange','bg-yellow','bg-green','bg-teal','bg-cyan','bg-gray'],
      detail:{
        name:"",
        unit_name:"",
        country_name:""
      }
    }
  },
  methods:{
    getContactList(){
        let userProfile = this.$store.getters.userProfile
        let payload = {
          company_id:userProfile.data.attributes.company_id,
          page:this.currentPage,
          limit:this.perPage
        }
        this.loading = true

        AxiosCall.Get(payload, urlApi.intranet.contact_list).then(res=>{
          if(res.success){
            for (let i in res.atributes){
              let data = res.atributes[i]
              const random = this.random()
              if(i != 0 ){
                data.bg_color = this.bg_color[random] === res.atributes[i-1].bg_color ? this.bg_color[this.random()] : this.bg_color[random]
              }else {
                data.bg_color = this.bg_color[random]
              }

              data.initial  = data.full_name.match(/\b(\w)/g).join('')
              this.contact_list.push(data)
            }
            if(this.contact_list.length > 0  && this.detail.name === "") this.getDetail(this.contact_list[0])
            this.currentPage++;
            this.total = res.total
          }else{
            this.$parent.errorMessage(res.message)
          }
          this.loading= false
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })

    },
    getDetail(item){
      let payload = {
        emp_id:item.id
      }
      AxiosCall.Get(payload, urlApi.intranet.contact_detail).then(res=>{
        if(res.success){
          this.detail = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    random(){
      let key = this.getRandomInt(0, 10);
      return key
    },
     getRandomInt(min, max) {
      // Create byte array and fill with 1 random number
      let byteArray = new Uint8Array(1);
      window.crypto.getRandomValues(byteArray);

      let range = max - min + 1;
      let max_range = 256;
      if (byteArray[0] >= Math.floor(max_range / range) * range)
        return this.getRandomInt(min, max);

      return min + (byteArray[0] % range);
    },
    inputText(){
      let myDiv = document.getElementById('container');
      myDiv.scrollTop = 0
    }
  },
  created() {
    this.contact_list = []
    this.getContactList()
  },
  mounted() {
    let ini = this
    if (window.PerfectScrollbar && $('.perfect-scrollbar').length > 0) {
      let ps
      $('.perfect-scrollbar:not(".aside-menu")').each(function () {
        if(this.id === 'container'){
          ps = new PerfectScrollbar(this, {
            suppressScrollX: true,
            wheelPropagation: false,
          })
          document.querySelector('#container').addEventListener('ps-y-reach-end', () => {
            setTimeout(()=>{
              if(!ini.loading) {
                  ini.getContactList()
              }
              setTimeout(()=>{
                ps.update()
              }, 10)
            }, 20)
          });
        }
      })
    }
  }
}
</script>

<style scoped>
.tile {
  font-size: 0.7vw;
}
</style>